/**
 * Метка рекламы с первого захода — для статистики источников (docs/ADMIN.md).
 *
 * Запоминается первая, а не последняя: регистрация бывает через дни после
 * захода, и за это время человек успевает открыть игру по ссылке друга или
 * из закладки. Приход засчитывается тому, что привело его впервые.
 *
 * На сервер уходит только при регистрации — отдельного запроса на заход нет:
 * гостя сервер между визитами не узнаёт, и считать ему было бы нечего.
 */

const KEY = 'ludo.utm_source'

/** Сколько символов метки хранить — столько же принимает сервер. */
const MAX = 64

/** Запомнить utm_source из адреса, если метки ещё нет. Зовётся при загрузке. */
export function rememberLanding(search: string = window.location.search): void {
  const label = new URLSearchParams(search).get('utm_source')?.trim().slice(0, MAX)

  if (label === undefined || label === '') return

  try {
    if (localStorage.getItem(KEY) === null) localStorage.setItem(KEY, label)
  } catch {
    // Приватный режим: метка потеряется, игре это не мешает.
  }
}

/** Запомненная метка или null. */
export function landingSource(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}
